var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:{ clicked: _vm.clicked },on:{"click":function($event){return _vm.$emit('cell_click', _vm.value)}}},[(_vm.clicked)?_c('span',[_vm._v(_vm._s(_vm.value))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }